import { useSize } from 'ahooks'
import { useEffect, useState } from 'react'

/**
 * 判断当前设备是否为移动端的 hooks
 * @returns {boolean} isMobile - 是否为移动端
 */
function useIsMobile() {
  const getIsMobile = (width?: number) => {
    if (typeof navigator === 'undefined') return false
    const ua = navigator.userAgent
    const isMobilePhone = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
    const screenWidth = width ?? (typeof window !== 'undefined' ? window.innerWidth : 9999)
    return screenWidth <= 1200 && isMobilePhone
  }

  const [isMobile, setIsMobile] = useState(() => getIsMobile())
  const root = document.documentElement

  const windowSize = useSize(root)

  useEffect(() => {
    if (windowSize === undefined) return
    setIsMobile(getIsMobile(windowSize.width))
  }, [windowSize])

  return isMobile
}

export default useIsMobile
